<div class="bl-margin-top--16">
  <div *ngFor="let account of mainAccount; let i = index;">
    <div
      class="bl-font-color--base bl-bg-color--snow bl-margin-top--16 bl-padding-y--24 bl-padding-x--16">
      <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450">
        <input type="checkbox" [disabled]='canDisableAccount(account)' [(ngModel)]="account.isSelected"
          (change)="primaryShareSelection(account)" name="{{account.name}}-accounts-{{i}}"
          id="{{account.name}}-accounts-{{i}}"
          [attr.data-automation-id]="'primary-accounts-'+i" 
          class="bl-display--inline-block">
        <label for="{{account.name}}-accounts-{{i}}"
          class="bl-font-color--black bl-font-weight--900 bl-font-size--18">
          {{account.name}}
        </label>
      </div>
      <div class="bl-font-color--black bl-font-size--16 bl-margin-top--16"
        *ngIf="account.description"
        [innerHtml]="account.description|safe:'html'"></div>
      <div class="bl-padding-left--32" *ngIf="hasJointApplicants(account) && account.isSelected && hasCoApplicant() && hasCoApplicantShares(i)">
        <div class="bl-font-color--steel bl-font-size--16 bl-margin-top--16 bl-margin-bottom--8 bl-font-weight--800">
          {{'oaoCheckingSavingAccounts/CoAppShares'|dictionary}}</div>
        <div *ngFor="let applicant of coAppProducts; let z = index;">
          <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450"
          [class.bl-margin-bottom--16]="z < coAppProducts.length-1">
            <input type="checkbox" name="'co-app-checking-accounts-{{z}}"
              id="checking-{{applicant.applicantId}}-{{applicant.shares[i].id}}-accounts-{{z}}"
              [attr.data-automation-id]="'co-app-checking-accounts-'+z"
              class="bl-display--inline-block" [(ngModel)]="applicant.shares[i].isSelected"
              (change)="coAppShareSelection(account, applicant)"
              [disabled]="account.isDisabled || (!account.isSelected) || (applicant.shares[i].isDisabled && applicant.shares[i].isDisabled === true)">
            <label for="checking-{{applicant.applicantId}}-{{applicant.shares[i].id}}-accounts-{{z}}"
              class="bl-font-size--16 bl-font-color--black  ">
              {{applicant.firstName | titlecase}} {{applicant.lastName | titlecase }}
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="account.optionalServices && account.optionalServices.length > 0 && account.isSelected">
        <h3 class="bl-text-style--default-text-2 bl-margin-top--24 bl-margin-bottom--8">
          {{'oaoCheckingSavingAccounts/OptionalService'|dictionary}}
        </h3>
        <div *ngFor="let option of account.optionalServices; let j = index;">
          <div class="ecp-workflow-max-width--450 bl-padding-left--16" [class.bl-margin-bottom--24]="account.optionalServices.length-1 < j" [class.bl-margin-top--16]="j>0">
            <div
              class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450 bl-margin-bottom--8">
              <input type="checkbox" [(ngModel)]="option.isSelected"
                (change)="setOptionalServiceSelection(account, option)"
                [disabled]="account.isDisabled || !account.isSelected"
                name="{{account.name}}-accounts-{{i}}-optional-{{j}}"
                id="{{account.name}}-accounts-{{i}}-optional-{{j}}"
                [attr.data-automation-id]="'primary-accounts-optional-'+i+'-'+j" 
                class="bl-display--inline-block">
              <label for="{{account.name}}-accounts-{{i}}-optional-{{j}}"
                class="bl-font-color--black  bl-font-size--16 bl-font-weight--800">
                {{option.name}}
              </label>
              <div class="bl-margin-top--8 bl-margin-bottom--8 bl-font-size--14"> <span *ngIf="option.description"
                  [innerHTML]="option.description|safe:'html'"></span> </div>
            </div>
            <div class="bl-margin-left--32"
              *ngIf="showCoApplicantsForOptionalServices(account.id) && option.isSelected && option.availableForJointOwner && hasJointApplicants(account) && hasOptionalServices()">
              <div class="bl-font-color--steel bl-font-size--16 bl-font-weight--800 bl-font-color--steel bl-margin-bottom--8">
                {{'oaoCheckingSavingAccounts/CoAppServices'|dictionary}}</div>
              <div *ngFor="let applicant of coAppProducts; let z = index;">
                <div
                  class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450"
                  [class.bl-margin-bottom--8]="z < coAppProducts.length-1"
                  *ngIf="applicant.shares[i].optionalServices[j].isVisible && applicant.shares[i].optionalServices[j].availableForJointOwner">
                  <input type="checkbox"
                    name="{{applicant.shares[i].id}}-{{applicant.shares[i].optionalServices[j].name}}-services-{{z}}"
                    id="{{applicant.shares[i].id}}-{{applicant.shares[i].optionalServices[j].name}}-services-{{z}}"
                    [attr.data-automation-id]="'co-app-optional-services-'+z"
                    class="bl-display--inline-block" [(ngModel)]="applicant.shares[i].optionalServices[j].isSelected"
                    [disabled]="account.isDisabled || isYouthMembership()"
                    (change)="coAppServiceSelection(applicant.bundlePath,applicant.shares[i].bundleIndex, applicant.shares[i].optionalServices[j].bundleIndex, applicant.shares[i].optionalServices[j].isSelected)">
                  <label
                    for="{{applicant.shares[i].id}}-{{applicant.shares[i].optionalServices[j].name}}-services-{{z}}"
                    class="bl-font-size--16 bl-font-color--black ">
                    {{applicant.firstName | titlecase}} {{applicant.lastName |titlecase }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>